import { FindAllReviewablePtMembershipsResponseDto } from '#types/rates';

interface ItemProps extends FindAllReviewablePtMembershipsResponseDto {
  selected: boolean;
  isPaid: boolean;
  onClick: () => void;
}

export const Item = ({
  title,
  totalRound,
  completedRoundUntilNow,
  startedDate,
  expiryDate,
  selected,
  isPaid,
  onClick
}: ItemProps) => {
  function formatDate(isoString: string) {
    // ISO 문자열을 Date 객체로 변환
    const date = new Date(isoString);

    // 연, 월, 일을 추출
    const year = date.getFullYear().toString().slice(2); // 연도 마지막 두 자리
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 월 (0부터 시작하므로 +1), 두 자리로 맞춤
    const day = String(date.getDate()).padStart(2, '0'); // 일, 두 자리로 맞춤

    // 원하는 형식으로 조합하여 반환
    return `${year}.${month}.${day}`;
  }

  // 남은 회차
  const restRound = totalRound - completedRoundUntilNow;

  return (
    <div
      style={{
        border: selected ? '1px solid #6238dd' : '1px solid transparent'
      }}
      className="w-full p-20 bg-[#2e2a3a] rounded-xl justify-between items-center inline-flex"
      onClick={onClick}
    >
      <div className="inline-flex flex-col items-start justify-start w-full gap-3">
        <div className="flex items-center self-stretch justify-between w-full gap-8">
          <div className="flex justify-center items-center gap-0.5">
            <div className="max-w-200 truncate text-left text-[#d7d2de] text-lg font-medium font-['Pretendard Variable'] leading-snug">
              {title}
            </div>
          </div>
          <div className="flex items-start justify-start gap-4">
            <div
              style={{
                backgroundColor: !isPaid ? '#e13a3a' : '#373245'
              }}
              className="whitespace-nowrap px-6 py-4 bg-[#e13a3a] rounded justify-center items-center gap-2.5 flex"
            >
              <div className="text-center text-[#d7d2de] text-xs font-medium font-['Pretendard Variable'] leading-none">
                {!isPaid ? '결제 예정' : '결제완료'}
              </div>
            </div>
            {CalculatedLecture(restRound)}
          </div>
        </div>
        <div className="h-[46px] flex-col justify-start items-start gap-4 flex">
          <div className="self-stretch text-[#938f9e] text-base font-normal font-['Pretendard Variable'] leading-[21px]">
            {completedRoundUntilNow} 회차 / {totalRound} 회차
          </div>
          <div className="self-stretch text-left text-[#938f9e] text-base font-normal font-['Pretendard Variable'] leading-[21px]">
            {formatDate(startedDate)} -{' '}
            {expiryDate ? formatDate(expiryDate) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

// 회원들의 수업 횟수를 계산하여 수업 중, 종료 임박, 종료 3가지로 나타내는 함수
// 총 수업 횟수가 3초과이면 수업 중, 3이하면 종료 임박, 0은 종료로 표시한다.
function CalculatedLecture(totalamount: number) {
  let color = '';
  let state = '';
  let width = '';
  let height = '';

  if (totalamount > 3) {
    state = '수업 중';
    color = '#6238dd';
    width = '47px';
    height = '24px';
  } else if (totalamount === 0) {
    state = '종료';
    color = '#756F7E';
    width = '33px';
    height = '24px';
  } else {
    state = '종료 임박';
    color = '#E13A3A';
    width = '57px';
    height = '24px';
  }
  return (
    <div
      style={{
        backgroundColor: color,
        width
      }}
      className="whitespace-nowrap px-6 py-4 rounded justify-center items-center gap-2.5 flex"
    >
      <div className="text-center text-[#d7d2de] text-xs font-medium font-['Pretendard Variable'] leading-none">
        {state}
      </div>
    </div>
  );
}
